var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.932,
    height: 14.932,
    viewBox: "0 0 14.932 14.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-management-482194",
    transform: "translate(-116.668 -46.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6307",
    "data-name": "Path 6307",
    d: "M306.321,48.161a1.493,1.493,0,1,1-1.493-1.493,1.493,1.493,0,0,1,1.493,1.493",
    transform: "translate(-180.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6308",
    "data-name": "Path 6308",
    d: "M257.415,166.321h4.48a.705.705,0,0,0,.747-.747V165.2a1.848,1.848,0,0,0-1.867-1.867h-2.24a1.848,1.848,0,0,0-1.867,1.867v.373A.705.705,0,0,0,257.415,166.321Z",
    transform: "translate(-135.52 -112.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6309",
    "data-name": "Path 6309",
    d: "M166.321,304.825a1.493,1.493,0,1,1-1.493-1.493,1.493,1.493,0,0,1,1.493,1.493",
    transform: "translate(-45.173 -248.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6310",
    "data-name": "Path 6310",
    d: "M120.774,420h-2.24a1.848,1.848,0,0,0-1.867,1.867v.373a.705.705,0,0,0,.747.747h4.48a.705.705,0,0,0,.747-.747v-.373A1.848,1.848,0,0,0,120.774,420Z",
    transform: "translate(0 -361.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6311",
    "data-name": "Path 6311",
    d: "M446.321,304.825a1.493,1.493,0,1,1-1.493-1.493,1.493,1.493,0,0,1,1.493,1.493",
    transform: "translate(-316.213 -248.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6312",
    "data-name": "Path 6312",
    d: "M400.774,420h-2.24a1.848,1.848,0,0,0-1.867,1.867v.373a.705.705,0,0,0,.747.747h4.48a.705.705,0,0,0,.747-.747v-.373A1.848,1.848,0,0,0,400.774,420Z",
    transform: "translate(-271.041 -361.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6313",
    "data-name": "Path 6313",
    d: "M280.112,282.76l-1.643-.971V280h-1.493v1.792l-1.643.971.747,1.269,1.643-.9,1.643.9Z",
    transform: "translate(-153.589 -225.864)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.9932caf2.svg";
export { ForwardRef as ReactComponent };